<template>
  <div class="pop-box rd_dialog" v-show="isShowing">
    <div class="block"></div>
    <div class="viewbox">
      <h3 class="tit-layer-3 marb_30" v-text="dialogTitle"></h3>
      <div class="txt marb_30" v-text="dialogMsg"></div>
      <div class="btn-tool row-mb row-pad">
        <template v-for="btnSetting in otherButtons">
          <div class="item">
            <button type="button" class="green-btn btn col-12" @click="onButtonClicked(btnSetting)" v-text="btnSetting.label">Confirm</button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
    import _ from "lodash";

    export default {
        name: "MessageDialog",
        props: {
        },
        data() {
            return {
                dialogTitle  : '系統訊息',
                isShowing    : false,
                dialogMsg    : "",    
                otherButtons : [],
            };
        },
        created() {
            
        },
        mounted() {
            
        },
        methods: {       
            showDialog(setting) {
                this.isShowing   = true;
                this.dialogTitle = _.isEmpty(setting.config.title   ) ? 'Notice'                   : setting.config.title;
                this.dialogMsg   = _.isEmpty(setting.config.msg     ) ? 'Error' : setting.config.msg;
                
                // 其他按鈕, 需要提供按鈕名稱 & onClick 事件
                // [
                //   { label: '取消', onClick: () => [callback] }
                // ]
                if (!_.isEmpty(setting.config.btns)) {
                    this.otherButtons = setting.config.btns;
                } 
                // 如果沒有給任何按鈕, 加一個預設的 'OK'
                else {
                    this.otherButtons = [{ label: 'OK', onClick: this.hideDialog }];
                } // end of method
            },
            /**
             * 隱藏 Message Dialog
             */
            hideDialog() {
                this.isShowing = false;
            },
            /**
             * 點擊按鈕
             * 
             * @param setting
             */
            onButtonClicked(setting) {
                if (typeof setting.onClick !== 'function') {
                    this.isShowing = false;
                } else {
                    setting.onClick();
                } // end of if
            },
            isShown() {
                return this.isShowing;
            }
        },
        computed: {
        },
    };
</script>
